import { c as _c } from "react/compiler-runtime";
import { useGraphAPI } from '@newfront-insurance/ms-graph-auth';
import type { ReactNode } from 'react';
import { MSGraphProvider } from '../chat-v2/contexts/ms-graph-context';
interface MSGraphRootProps {
  children: ReactNode;
  /** When true, MS Graph auth is active. When false, context is null and MSAL never initializes. */
  enabled?: boolean;
}

/**
 * Root primitive for MS Graph authentication.
 * Owns the useGraphAPI() call and provides auth state to all descendants via context.
 *
 * @example
 * // Feature-flag controlled (Navigator Nova)
 * <MSGraphRoot enabled={msGraphEnabled}>...</MSGraphRoot>
 */
export function MSGraphRoot(t0) {
  const $ = _c(4);
  const {
    children,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  if (!enabled) {
    let t2;
    if ($[0] !== children) {
      t2 = <MSGraphProvider value={null}>{children}</MSGraphProvider>;
      $[0] = children;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== children) {
    t2 = <MSGraphRootInternal>{children}</MSGraphRootInternal>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

/** Calls useGraphAPI — only rendered when enabled=true. */
function MSGraphRootInternal(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const msGraphAuth = useGraphAPI();
  let t1;
  if ($[0] !== children || $[1] !== msGraphAuth) {
    t1 = <MSGraphProvider value={msGraphAuth}>{children}</MSGraphProvider>;
    $[0] = children;
    $[1] = msGraphAuth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}